import * as React from "react";

import type { AppLocale } from "@/i18n/routing";

type LocaleRuntimeContextValue = {
  isLocaleChanging: boolean;
  setLocale: (locale: AppLocale) => void;
};

const noop = () => {};

const LocaleRuntimeContext = React.createContext<LocaleRuntimeContextValue>({
  isLocaleChanging: false,
  setLocale: noop,
});

export function LocaleRuntimeProvider({
  children,
  isLocaleChanging,
  setLocale,
}: {
  children: React.ReactNode;
  isLocaleChanging: boolean;
  setLocale: (locale: AppLocale) => void;
}) {
  const value = React.useMemo<LocaleRuntimeContextValue>(
    () => ({
      isLocaleChanging,
      setLocale,
    }),
    [isLocaleChanging, setLocale],
  );

  return <LocaleRuntimeContext.Provider value={value}>{children}</LocaleRuntimeContext.Provider>;
}

export function useLocaleRuntime() {
  return React.useContext(LocaleRuntimeContext);
}
